import { t as toMediaTypeString } from './media-type.js';

function canPlayType(mediaType) {
  const typeString = toMediaTypeString(mediaType);
  const testElement = document.createElement('video');
  return !!testElement.canPlayType(typeString);
}

export { canPlayType as c };
